import _ from 'lodash';

export default function preRegList({ stateInfos }) {
  const fifteen = [];
  const sixteen = [];
  const seventeen = [];
  const seventeenHalfPlus = [];
  const eighteenElectionDay = [];
  const noVoterReg = [];

  stateInfos.forEach((state) => {
    const stateData = _.keyBy(state.nodes, 'field_type');

    const noReg = state.fieldValue === 'North Dakota';
    const reg15 = stateData.minimum_age_register.text === '15';
    const reg16 = stateData.minimum_age_register.text === '16';
    const reg17 = stateData.minimum_age_register.text === '17';
    const reg17Half =
      parseFloat(stateData.minimum_age_register.text) >= 17.5 < 18;
    const preReg = stateData.has_preregistration.bool_value;

    if (noReg) {
      noVoterReg.push(state);
    } else if (reg15) {
      fifteen.push(state);
    } else if (reg16) {
      sixteen.push(state);
    } else if (reg17 && preReg) {
      seventeen.push(state);
    } else if (reg17Half && preReg) {
      seventeenHalfPlus.push(state);
    } else if ((reg17 && !preReg) || (reg17Half && !preReg)) {
      eighteenElectionDay.push(state);
    }
  });

  return [
    {
      title: 'Pre-registration available at 15 years old',
      states: fifteen,
    },
    {
      title: 'Pre-registration available at 16 years old',
      states: sixteen,
    },
    {
      title: 'Pre-registration available at 17 years old',
      states: seventeen,
    },
    {
      title: 'Pre-registration available at 17.5 years or older',
      states: seventeenHalfPlus,
    },
    {
      title:
        'Pre-registration available at 17 if you will be 18 by Election Day',
      states: eighteenElectionDay,
    },
    {
      title: `The state does not have voter registration`,
      states: noVoterReg,
    },
  ];
}
